module.exports = __webpack_public_path__ + "media/images/icon__matchdayNavigation--pagination--arrow@2x-5fab77862f6a6611e59eea8a3b4b1629.png";